import "clsx";
import { E as sanitize_props, F as spread_props, G as slot, I as attr, J as escape_html, D as pop, A as push } from "../../chunks/index2.js";
import { l as localizeHref, g as getLocale } from "../../chunks/runtime.js";
import { g as github_link_title, m as made_with_love, t as terms_of_use, i as imprint } from "../../chunks/imprint.js";
import { p as page } from "../../chunks/index4.js";
import { p as public_env } from "../../chunks/shared-server.js";
import { I as Icon } from "../../chunks/Icon.js";
function Github($$payload, $$props) {
  const $$sanitized_props = sanitize_props($$props);
  /**
   * @license lucide-svelte v0.542.0 - ISC
   *
   * ISC License
   *
   * Copyright (c) for portions of Lucide are held by Cole Bemis 2013-2023 as part of Feather (MIT). All other copyright (c) for Lucide are held by Lucide Contributors 2025.
   *
   * Permission to use, copy, modify, and/or distribute this software for any
   * purpose with or without fee is hereby granted, provided that the above
   * copyright notice and this permission notice appear in all copies.
   *
   * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
   * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
   * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
   * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
   * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
   * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
   * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
   *
   * ---
   *
   * The MIT License (MIT) (for portions derived from Feather)
   *
   * Copyright (c) 2013-2023 Cole Bemis
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to deal
   * in the Software without restriction, including without limitation the rights
   * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
   * copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in all
   * copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
   * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
   * SOFTWARE.
   *
   */
  const iconNode = [
    [
      "path",
      {
        "d": "M15 22v-4a4.8 4.8 0 0 0-1-3.5c3 0 6-2 6-5.5.08-1.25-.27-2.48-1-3.5.28-1.15.28-2.35 0-3.5 0 0-1 0-3 1.5-2.64-.5-5.36-.5-8 0C6 2 5 2 5 2c-.3 1.15-.3 2.35 0 3.5A5.403 5.403 0 0 0 4 9c0 3.5 3 5.5 6 5.5-.39.49-.68 1.05-.85 1.65-.17.6-.22 1.23-.15 1.85v4"
      }
    ],
    ["path", { "d": "M9 18c-4.51 2-5-2-7-2" }]
  ];
  Icon($$payload, spread_props([
    { name: "github" },
    $$sanitized_props,
    {
      /**
       * @component @name Github
       * @description Lucide SVG icon component, renders SVG Element with children.
       *
       * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTUgMjJ2LTRhNC44IDQuOCAwIDAgMC0xLTMuNWMzIDAgNi0yIDYtNS41LjA4LTEuMjUtLjI3LTIuNDgtMS0zLjUuMjgtMS4xNS4yOC0yLjM1IDAtMy41IDAgMC0xIDAtMyAxLjUtMi42NC0uNS01LjM2LS41LTggMEM2IDIgNSAyIDUgMmMtLjMgMS4xNS0uMyAyLjM1IDAgMy41QTUuNDAzIDUuNDAzIDAgMCAwIDQgOWMwIDMuNSAzIDUuNSA2IDUuNS0uMzkuNDktLjY4IDEuMDUtLjg1IDEuNjUtLjE3LjYtLjIyIDEuMjMtLjE1IDEuODV2NCIgLz4KICA8cGF0aCBkPSJNOSAxOGMtNC41MSAyLTUtMi03LTIiIC8+Cjwvc3ZnPgo=) - https://lucide.dev/icons/github
       * @see https://lucide.dev/guide/packages/lucide-svelte - Documentation
       *
       * @param {Object} props - Lucide icons props and any valid SVG attribute
       * @returns {FunctionalComponent} Svelte component
       * @deprecated Brand icons have been deprecated and are due to be removed, please refer to https://github.com/lucide-icons/lucide/issues/670. We recommend using https://simpleicons.org/?q=github instead. This icon will be removed in v1.0
       */
      iconNode,
      children: ($$payload2) => {
        $$payload2.out.push(`<!---->`);
        slot($$payload2, $$props, "default", {});
        $$payload2.out.push(`<!---->`);
      },
      $$slots: { default: true }
    }
  ]));
}
function Footer($$payload, $$props) {
  push();
  $$payload.out.push(`<footer class="svelte-11srx9u"><a data-sveltekit-reload="" rel="alternate" hreflang="en"${attr("href", localizeHref(page.url.pathname, { locale: "en" }))} class="svelte-11srx9u">EN</a> <a data-sveltekit-reload="" rel="alternate" hreflang="de"${attr("href", localizeHref(page.url.pathname, { locale: "de" }))} class="svelte-11srx9u">DE</a> <a data-sveltekit-reload="" rel="alternate" hreflang="sp"${attr("href", localizeHref(page.url.pathname, { locale: "sp" }))} class="svelte-11srx9u">SP</a> <a${attr("title", github_link_title())} href="https://github.com/CordlessWool/shrtn" target="_blank" rel="noopener noreferrer" class="svelte-11srx9u">`);
  Github($$payload, {});
  $$payload.out.push(`<!----></a> <span class="svelte-11srx9u">${escape_html(made_with_love())} <a href="https://dropanote.de" class="svelte-11srx9u">CordlessWool</a></span> `);
  if (public_env[`PUBLIC_LINK_TERMS_${getLocale().toUpperCase()}`]) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<a${attr("href", public_env[`PUBLIC_LINK_TERMS_${getLocale().toUpperCase()}`])} target="_blank" rel="noopener noreferrer" class="svelte-11srx9u">${escape_html(terms_of_use())}</a>`);
  } else {
    $$payload.out.push("<!--[!-->");
    if (public_env["PUBLIC_LINK_TERMS"]) {
      $$payload.out.push("<!--[-->");
      $$payload.out.push(`<a${attr("href", public_env["PUBLIC_LINK_TERMS"])} target="_blank" rel="noopener noreferrer" class="svelte-11srx9u">Terms of Use</a>`);
    } else {
      $$payload.out.push("<!--[!-->");
    }
    $$payload.out.push(`<!--]-->`);
  }
  $$payload.out.push(`<!--]--> `);
  if (public_env[`PUBLIC_LINK_TERMS_${getLocale().toUpperCase()}`]) {
    $$payload.out.push("<!--[-->");
    $$payload.out.push(`<a${attr("href", public_env[`PUBLIC_LINK_IMPRINT_${getLocale().toUpperCase()}`])} target="_blank" rel="noopener noreferrer" class="svelte-11srx9u">${escape_html(imprint())}</a>`);
  } else {
    $$payload.out.push("<!--[!-->");
    if (public_env["PUBLIC_LINK_IMPRINT"]) {
      $$payload.out.push("<!--[-->");
      $$payload.out.push(`<a${attr("href", public_env["PUBLIC_LINK_IMPRINT"])} target="_blank" rel="noopener noreferrer" class="svelte-11srx9u">Imprint</a>`);
    } else {
      $$payload.out.push("<!--[!-->");
    }
    $$payload.out.push(`<!--]-->`);
  }
  $$payload.out.push(`<!--]--></footer>`);
  pop();
}
function _layout($$payload, $$props) {
  let { children } = $$props;
  children($$payload);
  $$payload.out.push(`<!----> `);
  Footer($$payload);
  $$payload.out.push(`<!---->`);
}
export {
  _layout as default
};
